import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Flex } from '@uhg-abyss/web/ui/Flex';

export const ConfirmModal = ({ isOpen, closeModal, continueModal }) => {
  const handleClose = () => {
    closeModal();
  };
  const handleEdit = () => {
    continueModal();
  };
  return (
    <Modal id='phone-modal' isOpen={isOpen} hideClose={false} size='750px'>
      <Modal.Section>
        <Flex>
          <Flex.Content>
            <h3> Are you sure you want to leave this page? </h3>
            <p>If you do, your changes will not be saved</p>
          </Flex.Content>
        </Flex>
      </Modal.Section>
      <Modal.Actions>
        <Button
          data-testid='breadcrumb-Field-modal-cancel'
          onClick={handleEdit}
        >
          No, Continue Editing
        </Button>
        <Button
          variant='outline'
          data-testid='breadcrumb-Field-modal'
          onClick={handleClose}
        >
          Yes, Cancel and Leave Page
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  continueModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};
ConfirmModal.defaultProps = {
  isOpen: false,
};
